import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import {
    fillForm__Goteborg_Apartment,
    fillForm__Goteborg_House,
    fillForm__Kungalv_Apartment,
    fillForm__Kungalv_House
} from '../state/debugFiller';

export enum DebugMenuState {
    INITIAL = 'initial',
    EXPANDED = 'expanded',
    COLLAPSED = 'collapsed'
}

function toggleDebugMenuState(previousValue: DebugMenuState): DebugMenuState {
    switch (previousValue) {
        case DebugMenuState.INITIAL:
        case DebugMenuState.COLLAPSED: {
            return DebugMenuState.EXPANDED;
        }
        case DebugMenuState.EXPANDED: {
            return DebugMenuState.COLLAPSED;
        }
        default:
            throw new Error(`Invalid DebugMenu state: ${previousValue}`);
    }
}

const textColor = 'hsl(292.5, 87%, 82%)';

const buttonStyles = {
    color: textColor,
    textTransform: 'none',
    justifyContent: 'flex-start',
    fontSize: '18px',
    '&:hover': { backgroundColor: '#6b0879' }
};

export function CreateOrderDebugMenu() {
    let initialState = DebugMenuState.INITIAL;
    let [menuState, setMenuState] = React.useState<DebugMenuState>(initialState);

    function toggleDebugMenu() {
        setMenuState(toggleDebugMenuState);
    }

    return (
            <Box
                component="section"
                sx={{
                    backgroundColor: '#B10DC9',
                    color: 'hsl(292.5, 87%, 82%)',
                    borderRadius: '4px',
                    marginBottom: '16px'
                }}
            >
                <Box
                    component="span"
                    onClick={toggleDebugMenu}
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '16px',
                        cursor: 'pointer'
                    }}
                >
                    <Typography
                        variant="h2"
                        component="h2"
                        sx={{
                            margin: 0,
                            userSelect: 'none',
                            fontSize: '30px'
                        }}
                    >
                        Debug menu
                    </Typography>
                    {DebugMenuState.EXPANDED === menuState ? (
                        <IconButton aria-label="collapse">
                            <ExpandLessIcon sx={{ color: textColor }} />
                        </IconButton>
                    ) : (
                        <IconButton aria-label="expand">
                            <ExpandMoreIcon sx={{ color: textColor }} />
                        </IconButton>
                    )}
                </Box>
                <Box
                    component="article"
                    className={`debugMenu-contentContainer debugMenu${
                        DebugMenuState.EXPANDED === menuState ? '--expanded' : '--collapsed'
                    }`}
                >
                    <Button
                        variant="text"
                        sx={buttonStyles}
                        onClick={() => {
                            toggleDebugMenu();
                            fillForm__Goteborg_Apartment();
                        }}
                    >
                        Fill form [Göteborg, Apartment]
                    </Button>
                    <Button
                        variant="text"
                        sx={buttonStyles}
                        onClick={() => {
                            toggleDebugMenu();
                            fillForm__Goteborg_House();
                        }}
                    >
                        Fill form [Göteborg, House]
                    </Button>
                    <Button
                        variant="text"
                        sx={buttonStyles}
                        onClick={() => {
                            toggleDebugMenu();
                            fillForm__Kungalv_Apartment();
                        }}
                    >
                        Fill form [Kungälv, Apartment]
                    </Button>
                    <Button
                        variant="text"
                        sx={buttonStyles}
                        onClick={() => {
                            toggleDebugMenu();
                            fillForm__Kungalv_House();
                        }}
                    >
                        Fill form [Kungälv, House]
                    </Button>
                </Box>
            </Box>
    );
}
